import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { OrderFulfillmentContainerLocationDetailFragmentDoc } from './orderFulfillmentContainerLocationDetail.generated';
export type OrderFulfillmentDetailFragment = { __typename?: 'OrderFulfillment', id: string, status: Types.OrderFulfillmentStatus, type: string, timestamp: string, created_by_id: string, created_by_name: string, event_account_id: string, authorized_signer_id?: string | null, authorized_signer_name?: string | null, assets: Array<{ __typename?: 'TrackableItem', id: string, name: string, epc_tag: string, item_type: { __typename?: 'ItemType', id: number, name: string, image_url?: string | null, color_hex_code?: string | null, category: Types.ItemTypeCategory } }>, container_stations: Array<{ __typename?: 'OrderFulfillmentContainerStation', id: string, name: string, returned_sealed: boolean, counted_at?: string | null, status: Types.ContainerStationStatus, item_type: { __typename?: 'ItemType', id: number, name: string, color_hex_code?: string | null, category: Types.ItemTypeCategory, epc_asset_id: number, image_url?: string | null, archived: boolean }, containers: Array<{ __typename?: 'OrderFulfillmentContainerLocation', container_id: string, container_name: string, container_type_id: number, container_type_name: string, container_type_image?: string | null, owner_till?: string | null, next_owner_id?: string | null }>, manual_amounts: Array<{ __typename?: 'ContainerTypeAmount', container_type_id: number, container_type_name: string, container_type_image?: string | null, amount: number, amount_sealed: number }>, pictures: Array<{ __typename?: 'OrderFulfillmentPicture', id: string, url: string, url_full_size: string, created_at: string, created_by_id: string, created_by_name: string, comment?: string | null, taken_at?: string | null, street?: string | null, city?: string | null, country_code?: string | null, postal_code?: string | null, latitude?: number | null, longitude?: number | null }> }>, single_containers: Array<{ __typename?: 'OrderFulfillmentContainerLocation', container_id: string, container_name: string, container_type_id: number, container_type_name: string, container_type_image?: string | null, owner_till?: string | null, next_owner_id?: string | null }>, goodwill: Array<{ __typename?: 'ContainerTypeAmount', container_type_id: number, container_type_name: string, container_type_image?: string | null, amount: number, amount_sealed: number }>, manual_amounts: Array<{ __typename?: 'ContainerTypeAmount', container_type_id: number, container_type_name: string, container_type_image?: string | null, amount: number, amount_sealed: number }>, item_location: { __typename?: 'ItemLocation', id: string, name: string }, event: { __typename?: 'Event', id: string, name?: string | null, is_deleted: boolean }, pictures: Array<{ __typename?: 'OrderFulfillmentPicture', id: string, url: string, url_full_size: string, created_at: string, created_by_id: string, created_by_name: string, comment?: string | null, taken_at?: string | null, street?: string | null, city?: string | null, country_code?: string | null, postal_code?: string | null, latitude?: number | null, longitude?: number | null }> };

export const OrderFulfillmentDetailFragmentDoc = gql`
    fragment OrderFulfillmentDetail on OrderFulfillment {
  id
  status
  type
  timestamp
  created_by_id
  created_by_name
  event_account_id
  assets {
    id
    name
    epc_tag
    item_type {
      id
      name
      image_url
      color_hex_code
      category
    }
  }
  container_stations {
    id
    name
    item_type {
      id
      name
      color_hex_code
      category
      epc_asset_id
      image_url
      archived
    }
    returned_sealed
    counted_at
    status
    containers {
      ...OrderFulfillmentContainerLocationDetail
    }
    manual_amounts {
      container_type_id
      container_type_name
      container_type_image
      amount
      amount_sealed
    }
    pictures {
      id
      url
      url_full_size
      created_at
      created_by_id
      created_by_name
      comment
      taken_at
      street
      city
      country_code
      postal_code
      latitude
      longitude
    }
  }
  single_containers {
    ...OrderFulfillmentContainerLocationDetail
  }
  goodwill {
    container_type_id
    container_type_name
    container_type_image
    amount
    amount_sealed
  }
  manual_amounts {
    container_type_id
    container_type_name
    container_type_image
    amount
    amount_sealed
  }
  item_location {
    id
    name
  }
  authorized_signer_id
  authorized_signer_name
  event {
    id
    name
    is_deleted
  }
  pictures {
    id
    url
    url_full_size
    created_at
    created_by_id
    created_by_name
    comment
    taken_at
    street
    city
    country_code
    postal_code
    latitude
    longitude
  }
}
    ${OrderFulfillmentContainerLocationDetailFragmentDoc}`;